import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";
import {convertToHumanAmount, formatAmount, formatPrice, SOL_MINT, SOL_TOKEN} from "../../shared";
import {useCacheStore, useWalletStore} from "@/pinia";
import AccountAddress from "@/components/common/AccountAddress.vue";
import FundWithdraw from "@/components/bot/FundWithdraw.vue";
import FundDeposit from "@/components/bot/FundDeposit.vue";
import Alert from "@/components/common/Alert.vue";

//data

export default /*#__PURE__*/_defineComponent({
  __name: 'FundWallet',
  setup(__props) {

const panelOpen = ref<number>(0)

// store
const cacheStore = useCacheStore();
const walletStore = useWalletStore();

//computed

const modalTitle = computed<string>(() => {
	switch (panelOpen.value) {
		case 1:
			return "Withdraw";
		case 2:
			return "Deposit";
		default:
			return "Wallet"
	}
});

function openWithdraw() {
	if(panelOpen.value === 1) {
		panelOpen.value = 0
		return
	}

	panelOpen.value = 1
}
function openDeposit() {
	if(panelOpen.value === 2) {
		panelOpen.value = 0
		return
	}

	panelOpen.value = 2
}


return { __sfc: true,panelOpen, cacheStore, walletStore, modalTitle, openWithdraw, openDeposit, convertToHumanAmount, formatAmount, formatPrice, SOL_MINT, SOL_TOKEN, AccountAddress, FundWithdraw, FundDeposit, Alert }
}

})